export default __webpack_public_path__ + "static/media/ai-brain-white.be89c50f.png";